import React from 'react';

import { P } from '../P/P';
import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE4_3 = () => (
  <Section>

    <UL>
      <LI>
        <P gapBefore>
          Jede Arbeitsgruppe stellt ihre Ergebnisse als <b>Lernstation</b> für alle vor. <b>Diskutieren</b> Sie anschließend im Klassenverband,
          was davon leicht umzusetzen ist bzw. was ggf. gegen eine Umsetzung spricht: z. B. Zeit oder Kosten für Fair Trade.
          In diesem Zusammenhang können Sie auch das Prinzip „Cost per Wear“ einführen, d. h. die Kosten für jedes einzelne Mal,
          wenn man ein Kleidungsstück trägt, ausrechnen lassen, wodurch Fair Fashion, die länger haltbar ist als Fast Fashion,
          im Endeffekt nicht teurer ist. (Stichworte: Qualität, Reduktion, Wertschätzung etc.). Nach dem Prinzip des folgenden
          Films können Sie Thesen und Antithesen aufstellen lassen:
        </P>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE4_3.js